import {
    ChangeDetectionStrategy, Component, OnInit,
} from '@angular/core';

import { ProductDebugComponent } from '../product-debug/product-debug.component';
import { ProductViewBadgeComponent } from '../product-view/components/product-view-badge/product-view-badge.component';
import { ProductViewFooterComponent } from '../product-view/components/product-view-footer/product-view-footer.component';
import { ViewModelProductView } from '../product-view/models/product-view-config.model';
import { ProductViewTemplateModel } from '../product-view/models/product-view-template.model';
import { ProductViewComponent } from '../product-view/product-view.component';
import { ProductViewNavigationService } from '../product-view/services/product-view-navigation.service';
import { getTemplateConfigView } from '../product-view/services/product-view-template-config.service';
import { ProductViewService } from '../product-view/services/product-view.service';
import { getMultipleMediaProductView } from '../product-view/transformers/product-view-media.model.transformer';

import { ProductPublicModels } from '@features/products/product';
import { WishlistFeatureModule } from '@features/wishlist/wishlist-feature.module';
import { InViewportDirective } from '@layout/ui/directives/inviewport.directive';
import { UiService } from '@layout/ui/services/ui.service';
import { ViewItemService } from '@shared/analytics/COMMON/services/product-view/view-item.service';
import { MediaSkeletonComponent, ProductCardComponent } from '@shared/media';
import { getPricesProductSyncUseCase } from '@shared/prices/use-cases/get-prices.use-cases';

@Component({
    selector: 'product-view-mono-studio',
    templateUrl: './product-view-mono-studio.component.html',
    imports: [
        MediaSkeletonComponent,
        ProductCardComponent,
        ProductViewFooterComponent,
        ProductViewBadgeComponent,
        InViewportDirective,
        WishlistFeatureModule,
        ProductDebugComponent,
    ],
    providers: [
        ProductViewService,
        ProductViewNavigationService,
        ViewItemService,
        UiService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class ProductViewMonoStudioComponent extends ProductViewComponent implements OnInit {
    public templateConfig: ProductViewTemplateModel[];

    protected override generateViewModel(product: ProductPublicModels.PublicProduct, priority: boolean):
    ViewModelProductView {
        const prices = getPricesProductSyncUseCase(this.store, product);

        // eslint-disable-next-line max-len
        const medias = getMultipleMediaProductView({ color: product.status.selectedColor, multipleMedias: this.config().multipleMedias });
        const idMedia = medias.videos[0]?.idMedia || medias.images[0].idMedia;

        const templateConfig = getTemplateConfigView(
            product,
            this.config(),
            this.categoryConfig(),
            this.store,
            false,
            priority,
            idMedia,
        );

        this.templateConfig = medias.images.map((_, index) => {
            return {
                ...templateConfig,
                media: {
                    ...templateConfig.media,
                    imagePriority: templateConfig.media.imagePriority && index === 0,
                },
            };
        });

        return {
            medias, product, templateConfig, prices, linkHref: undefined,
        };
    }
}
